module.exports = __webpack_public_path__ + "img/c14.7f51aa86.png";